// The parts of every school day that aren't classes, shown as shaded rows in
// the schedule tables. Form 29 prints the same ones (backend
// src/pdf-generator/form29.ts, FIXED_ROWS); keep the two in step.
export const SCHOOL_DAY_ROWS = [
  { time: '07:30 - 07:45', label: 'Flag Raising Ceremony (Monday) / Clean-Up Period' },
  { time: '09:45 - 10:00', label: 'Health Break' },
  { time: '12:00 - 13:00', label: 'Lunch' },
  { time: '16:30 - 17:00', label: '7S (Housekeeping/Sports Club) / Flag Retreat (Friday)' },
];

const startMinutes = (time) => {
  const [h, m] = String(time ?? '').split(/[:\s]/).map(Number);
  return Number.isFinite(h) ? h * 60 + (m || 0) : Infinity;
};

// A schedule's rows (one per time slot, `time` as "HH:mm[:ss] - HH:mm[:ss]")
// with the school-day rows slotted in by start time. Those rows carry their
// text in `schoolDay` (for UiTableCard's band-label) and no class ids, so
// nothing can be removed from them. An empty schedule stays empty, so the
// table still says there are no classes.
export function withSchoolDayRows(rows) {
  if (!rows?.length) return rows ?? [];
  const fixed = SCHOOL_DAY_ROWS.map((row, i) => ({ id: `school-day-${i}`, time: row.time, schoolDay: row.label }));
  return [...fixed, ...rows].sort((a, b) => startMinutes(a.time) - startMinutes(b.time));
}

// For UiTableCard's band-label prop.
export const schoolDayLabel = (row) => row.schoolDay;
